import React from 'react';
import { Checkbox } from 'components/styled-primitives';
import { InputContainer } from '../../components';

interface AuthorizedDevicesOverrideProps {
  checkboxState?: boolean;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  isCreateLicense?: boolean;
  // `checked` is accepted (but unused) by callers/tests; kept for prop compatibility
  checked?: boolean;
}

const AuthorizedDevicesOverride = ({
  checkboxState,
  onChange,
  isCreateLicense,
}: AuthorizedDevicesOverrideProps): React.JSX.Element | false =>
  !isCreateLicense && (
    <InputContainer>
      <Checkbox
        name="authorized-devices-override"
        label="Authorized Devices Override"
        checked={checkboxState}
        onChange={onChange}
      />
    </InputContainer>
  );

export default AuthorizedDevicesOverride;
